import _styled from "@emotion/styled/base";
import isPropValid from '@emotion/is-prop-valid';
export var Name = /*#__PURE__*/_styled("div", true ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && prop !== "color";
  },
  target: "e11xcj1q0"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && prop !== "color";
  },
  target: "e11xcj1q0",
  label: "Name"
})("white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{", function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.buttonLarge;
}, ";}" + (true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvSW50ZWdyYXRpb25DYXJkL05hbWUvTmFtZS52aWV3cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTb0giLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9JbnRlZ3JhdGlvbkNhcmQvTmFtZS9OYW1lLnZpZXdzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgaXNQcm9wVmFsaWQgZnJvbSAnQGVtb3Rpb24vaXMtcHJvcC12YWxpZCdcblxuaW1wb3J0IHR5cGUgeyBUaGVtZUNvbG9ycyB9IGZyb20gJ0BzZWdtZW50L21hdGNoYS9mb3VuZGF0aW9ucy9UaGVtZSdcblxuZXhwb3J0IGludGVyZmFjZSBOYW1lUHJvcHMge1xuICBjb2xvcjogVGhlbWVDb2xvcnNcbn1cblxuZXhwb3J0IGNvbnN0IE5hbWUgPSBzdHlsZWQoYGRpdmAsIHsgc2hvdWxkRm9yd2FyZFByb3A6IChwcm9wKSA9PiBpc1Byb3BWYWxpZChwcm9wKSAmJiBwcm9wICE9PSBgY29sb3JgIH0pPE5hbWVQcm9wcz5gXG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICBkaXNwbGF5OiBibG9jaztcbiAgJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS50eXBvZ3JhcGh5LmJ1dHRvblNtYWxsfTtcbiAgY29sb3I6ICR7KHsgY29sb3IgfSkgPT4gY29sb3J9O1xuXG4gICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuYnJlYWtwb2ludHMudXAoYG1kYCl9IHtcbiAgICAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnR5cG9ncmFwaHkuYnV0dG9uTGFyZ2V9O1xuICB9XG5gXG4iXX0= */"));